import { css } from "emotion";

import { colors } from "@cobliteam/base-components/src/styles/colors";
import { fonts } from "@cobliteam/base-components/src/styles/fonts";

export const contentContainer = css`
  padding: 0 20px;
`;

export const radioGroup = css`
  margin-top: 20px;

  && {
    display: flex;
    flex-direction: row;
  }

  & > *:not(:first-of-type) {
    margin-left: 30px;
  }
`;

export const pickerWrapper = css`
  display: flex;
  flex-direction: column;
  margin: 21px 0 0;
`;

export const pickerPeriod = css`
  max-width: 438px;
`;

export const pickerDate = css`
  max-width: 175px;
`;

export const action = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const cancelButton = css`
  margin-right: 40px;
`;

export const info = css`
  margin: 20px 0 0;
  min-width: 438px;
  font-size: ${fonts.size.small};
  font-weight: ${fonts.weight.light};
  color: ${colors.black};

  &:not(:first-of-type) {
    margin-top: 40px;
  }
`;

export const errorInfo = css`
  width: 165px;
  margin: 5px 10px 10px 0;
  line-height: 17px;
  font-size: ${fonts.size.smallest};
  font-weight: ${fonts.weight.regular};
  color: ${colors.error.default};
`;

export const errorWrapper = css`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  height: 50px;
`;
